// /*
//  *  Warning! This is...
//  *
//  *  _____               _            _   _
//  * |  __ \             | |          | | (_)
//  * | |__) | __ ___   __| |_   _  ___| |_ _  ___  _ __
//  * |  ___/ '__/ _ \ / _` | | | |/ __| __| |/ _ \| '_ \
//  * | |   | | | (_) | (_| | |_| | (__| |_| | (_) | | | |
//  * |_|   |_|  \___/ \__,_|\__,_|\___|\__|_|\___/|_| |_|
//  *
//  *
//  **/

import { LogLevel } from '@azure/msal-browser';
import { Policy } from '../enums/policy.enum';
import { TenantId } from '../enums/tenant-id.enum';
import { ClientB2C } from '../types/ClientB2C';
import { ClientEnvironment } from '../types/ClientEnvironment';

type TenantName = 'testulplatform';
type AuthorityDomainTld = 'b2clogin.com';
type TenantDomainTld = 'onmicrosoft.com';

declare global {
	namespace NodeJS {
		interface ProcessEnv {
			GITHUB_AUTH_TOKEN: string;
			NODE_ENV: 'development' | 'production';
			PORT?: string;
			PWD: string;
			SERVICEBUS_HOSTNAME?: string;
			QUEUE_NAME?: string;
			AZURE_TENANT_ID?: string;
			AZURE_CLIENT_ID?: string;
			AZURE_CLIENT_SECRET?: string;
		}
	}
}

export const b2c: ClientB2C = {
	logLevel: LogLevel.Warning,
	clientId: 'de39f677-98f3-4e8c-ade3-180ea7607a08',
	tenantId: TenantId.Prod,
	tenantDomain: `login.ul.com`,
	authorityDomain: 'login.ul.com',
	policies: {
		[Policy.SignUpSignIn]: 'B2C_1A_Signup_Signin_Production',
		[Policy.ResetPassword]: 'B2C_1A_Password_Reset_Production',
		[Policy.EditProfile]: 'B2C_1A_Edit_Profile_Production',
	},
	redirects: {
		login: '/auth/sign-in',
		logout: '/auth/sign-out',
	},
	scope: 'https://login.ul.com/case-management/Read openid profile offline_access', // Important - Include offline_access to also request a refresh token
	scopes: {
		read: 'https://login.ul.com/case-management/Read',
		write: 'https://login.ul.com/case-management/Write',
	},
};

export const protectedResourceMap = new Map<string, string[]>([
	[
		'https://api-cm-prod-ncus.azurewebsites.net/v1/*',
		['https://login.ul.com/case-management/Read'],
	],
]);

export const environment: ClientEnvironment = {
	production: false,
	uLSubscriptionKey: '74c2b7a1fc83467598465255f57f39da',
	baseUrl: 'https://di.ul.com/tic/casemanagement/v1/',
	getLocationUrl: 'location',
	getCategoryUrl: 'Category',
	getCaseListUrl: 'Case',
	getCaseDetailsUrl: 'Case',
	saveCaseUrl: 'case/SaveCase',
	uploadFileUrl: 'case/UploadFile',
	createCaseUrl: 'case/CreateCase',
	getCommentsUrl: 'case/comments',
	getContactInfoUrl: 'user/getuserinfo',
	downloadAttachment: 'Attachments/Download',
	createCommentsAttachments: 'case/SaveCommentAndAttachment',
};
